<template>
  <div
    class="group relative flex flex-col gap-4 max-h-fit p-4 rounded-xl text-white"
    :class="theme.bg"
  >
    <!-- same hover zoom as ProductCardImage -->
    <div class="hidden md:block overflow-hidden rounded-lg">
      <img
        class="w-full aspect-[3/2] h-[208px] object-cover duration-300 ease-in-out group-hover:scale-105"
        :src="image"
        alt=""
        loading="lazy"
      />
    </div>
    <div class="flex gap-3 md:flex-col md:gap-2">
      <span
        class="md:hidden shrink-0 self-start flex p-2 rounded-lg bg-white/20"
      >
        <component :is="icon" class="w-5 h-5" />
      </span>
      <span
        class="hidden md:inline-flex self-start items-center gap-1 px-1.5 py-0.5 rounded bg-white/85 text-caption-small font-bold uppercase"
        :class="theme.text"
      >
        <component :is="icon" class="w-4 h-4" />
        {{ badgeLabel }}
      </span>
      <div>
        <div class="font-medium text-label leading-snug">{{ title }}</div>
        <div class="mt-1 text-xs text-caption-small text-white/90">
          {{ subtitle }}
        </div>
      </div>
    </div>
    <!-- mobile: after:inset-0 stretches the CTA over the whole card.
         md+: the CTA itself becomes an invisible overlay covering the card,
         so the card stays clickable and focusable without a visible button -->
    <Button
      color="on-color"
      :link="link"
      class="mt-auto w-full py-2.5 font-semibold text-label after:absolute after:inset-0 after:content-[''] md:absolute md:inset-0 md:m-0 md:h-auto md:rounded-xl md:bg-transparent md:text-transparent md:hover:bg-transparent md:hover:shadow-none md:focus-visible:outline md:focus-visible:outline-2 md:focus-visible:outline-offset-2 md:focus-visible:outline-teal-900"
      :class="theme.text"
      @click="emit('click')"
    >
      {{ ctaLabel }}
    </Button>
  </div>
</template>
<script setup lang="ts">
import type { Component } from 'vue'

type PromoCardColor = 'red' | 'teal'

const {
  color,
  icon,
  badgeLabel,
  title,
  subtitle,
  ctaLabel,
  image,
  link = '',
} = defineProps<{
  color: PromoCardColor
  icon: Component
  badgeLabel: string
  title: string
  subtitle: string
  ctaLabel: string
  image: string
  link?: string
}>()

const emit = defineEmits<{ click: [] }>()

// white on teal-600 is AA, not AAA — accepted in the design
const THEMES: Record<PromoCardColor, { bg: string; text: string }> = {
  red: { bg: 'bg-red-800', text: 'text-red-800' },
  teal: { bg: 'bg-blue-600', text: 'text-teal-700' },
}
const theme = computed(() => THEMES[color])
</script>
